<template>
  <div class="d-none d-md-block pb-5">
    <div class="desktop-app-wrapper">
      <div class="page-control">
        <div
          class="prev ns"
          @click="previousPage"
          :style="{
            'pointer-events': currentPage > 1 ? 'auto' : 'none',
          }"
        >
          <svg
            class="svg-inline-element fa-chevron-left"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="chevron-left"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            :style="{
              display: 'inline-block',
              height: '1em',
              overflow: 'visible',
              'vertical-align': '-0.125em',
            }"
          >
            <path
              class=""
              fill="currentColor"
              d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"
            ></path>
          </svg>
        </div>
        <div class="number">
          <span class="current-number"> {{ currentPage }}</span
          ><span> / {{ totalPages }}</span>
        </div>

        <div
          class="next ns"
          @click="nextPage"
          :style="{
            'pointer-events': currentPage < totalPages ? 'auto' : 'none',
          }"
        >
          <svg
            class="svg-inline-element fa-chevron-right"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="chevron-right"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            :style="{
              display: 'inline-block',
              height: '1em',
              overflow: 'visible',
              'vertical-align': '-0.125em',
            }"
          >
            <path
              class=""
              fill="currentColor"
              d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"
            ></path>
          </svg>
        </div>
      </div>

      <div class="category-list">
        <div class="category" @click="selecteCategory(0)">
          {{ currentLanguage != "zh-hans" ? "All categories" : "所有项目" }}
        </div>
        <div
          class="category"
          v-for="category in categories"
          :key="category.id"
          :value="category.id"
          @click="selecteCategory(category.id)"
        >
          {{ category.name }}
        </div>
      </div>

      <div class="projects">
        <div
          class="project"
          v-for="project in paginatedImages"
          :key="project.id"
        >
          <a :href="project.link">
            <div class="project-content">
              <div
                @error="onImageLoadFailure($event)"
                class="image"
                v-bind:style="`background-image: url(${project?.imageUrl});`"
              >
                <div class="gradient"></div>
                <div class="text">
                  <div class="category"></div>
                  <div class="project-name">{{ project?.title?.rendered }}</div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="d-block d-md-none">
    <div class="mobile-app-wrapper">
      <div class="app h-100 d-flex flex-column p-0 m-0">
        <div class="row h-25">
          <div class="selector col-12">
            <div class="select">
              <select v-model="selectedCategory">
                <option value="">
                  {{
                    currentLanguage != "zh-hans" ? "All categories" : "所有项目"
                  }}
                </option>
                <option
                  v-for="category in categories"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.name }}
                </option>
              </select>
              <svg
                class="svg-inline-element fa-caret-down text-white"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="caret-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  class=""
                  fill="currentColor"
                  d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"
                ></path>
              </svg>
            </div>
          </div>
        </div>

        <div class="row flex-grow-1">
          <div class="projects col-12">
            <div
              class="project-item project"
              @error="onImageLoadFailure($event)"
              v-bind:style="`background-image: url(${filteredProjects[selectedProject]?.imageUrl});`"
            >
              <div class="project-item--content">
                <div class="mask"></div>
                <h2>
                  {{ filteredProjects[selectedProject].title.rendered }}
                </h2>
                <a :href="filteredProjects[selectedProject].link" class="view">
                  VIEW
                </a>
              </div>
            </div>

            <div class="controller">
              <div
                class="arrow"
                @click="prevImage"
                :style="{
                  'pointer-events': selectedProject > 0 ? 'auto' : 'none',
                }"
              >
                <svg
                  class="svg-inline-element fa-chevron-left text-white"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="chevron-left"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  :style="{
                    display: 'inline-block',
                    height: '1em',
                    overflow: 'visible',
                    'vertical-align': '-0.125em',
                  }"
                >
                  <path
                    class=""
                    fill="currentColor"
                    d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"
                  ></path>
                </svg>
              </div>
              <h4>{{ selectedProject + 1 }} /{{ filteredProjects.length }}</h4>
              <div
                class="arrow"
                @click="nextImage"
                :style="{
                  'pointer-events':
                    selectedProject < filteredProjects.length - 1
                      ? 'auto'
                      : 'none',
                }"
              >
                <svg
                  class="svg-inline-element fa-chevron-right text-white"
                  :style="{
                    display: 'inline-block',
                    height: '1em',
                    overflow: 'visible',
                    'vertical-align': '-0.125em',
                  }"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="chevron-right"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    class=""
                    fill="currentColor"
                    d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "DeveloperProjectsGrid",
  data() {
    return {
      projects: [],
      projectWithImage: [],
      categories: [],
      selectedCategory: "",
      selectedProject: 0,
      currentPage: 1,
      imagesPerPage: 4,
      totalPage: 4,
      currentUrl: null,
      currentRoutePath: null,
      currentRouteFullPath: null,
      currentLanguage: null,
    }
  },
  async mounted() {
    this.currentLanguage = window.developmentProjectsProps.currentLanguage
    this.fetchProjects()
    this.fetchCategories()
  },
  created() {},
  methods: {
    async fetchProjects() {
      const developerProjects = await axios.get(
        "/wp-json/wp/v2/development-project?lang=" +
          window.developmentProjectsProps.currentLanguage
      )
      developerProjects.data.forEach(async (project) => {
        try {
          const imageResponse = await axios.get(
            `/wp-json/wp/v2/media/${project.acf?.gallery[0]}`
          )

          project.imageUrl =
            imageResponse.data.media_details?.sizes?.large?.source_url
          this.projects.push(project)
        } catch (err) {
          console.log(err)
        }
      })
    },
    onImageLoadFailure(event) {
      console.log("ERRROR", event.target)
    },

    async fetchCategories() {
      const categories = await axios.get(
        "/wp-json/wp/v2/development_project_categories?lang=" +
          window.developmentProjectsProps.currentLanguage
      )

      this.categories = categories.data
      console.log("categories", categories.data)
    },

    previousPage() {
      this.currentPage > 1 ? this.currentPage-- : (this.currentPage = 1)
    },
    nextPage() {
      this.currentPage++
    },
    nextImage() {
      this.selectedProject++
    },
    prevImage() {
      this.selectedProject--
      // this.selectedProject > 0
      //   ? this.selectedProject--
      //   : (this.selectedProject = 0)
    },
    selecteCategory(val) {
      this.selectedCategory = val
    },
    getCategoryName(categoryId) {
      const category = this.categories.find(
        (category) => category.id === categoryId
      )
      return category ? category.name : ""
    },
  },
  watch: {
    selectedCategory() {
      this.currentPage = 1
      this.selectedProject = 0
    },
  },

  computed: {
    filteredProjects() {
      if (!this.selectedCategory) {
        return this.projects
      }

      return this.projects.filter(
        (project) =>
          !project.development_project_categories.includes(
            parseInt(this.selectedCategory)
          )
      )
    },

    paginatedImages() {
      const startIndex = (this.currentPage - 1) * this.imagesPerPage
      const endIndex = startIndex + this.imagesPerPage

      return this.filteredProjects.slice(startIndex, endIndex)
    },

    totalPages() {
      return Math.ceil(this.filteredProjects.length / this.imagesPerPage)
    },
  },
}
</script>

<style scoped>
body {
  line-height: 1.6;
  font-size: 16px;
  font-weight: 400;
  color: #404040;
}
.svg-inline-element-element {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
#development-projects {
  min-height: 850px;
  height: 100%;
  width: 100%;
}
.desktop-app-wrapper {
  width: 100%;
  position: relative;
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 120px;
}
.desktop-app-wrapper .category-list {
  min-width: 150px;
  margin-top: -5px;
  width: 20%;
}
.desktop-app-wrapper .category-list .category {
  color: #c3c3c3;
  font-weight: 300;
  font-size: 18px;
  padding: 10px 0;
  margin-bottom: 15px;
  position: relative;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.desktop-app-wrapper .category-list .category.active {
  color: #fff;
}
.desktop-app-wrapper .category-list .category.active:after {
  content: " ";
  height: 2px;
  width: 41px;
  position: absolute;
  background-color: #ffd83b;
  left: -57px;
  top: 23px;
}
.desktop-app-wrapper .category-list .category:hover {
  color: #fff;
}
.desktop-app-wrapper .projects {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 0;
}
.desktop-app-wrapper .projects .project {
  width: 50%;
  height: 500px;
  padding: 8px;
}
.desktop-app-wrapper .projects .project .project-content {
  background-size: cover;
  background-position: 50%;
  height: 100%;
  width: 100%;
  background-color: #ddd;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.desktop-app-wrapper .projects .project .project-content .image {
  transform: scale(1.15);
  background-size: cover;
  background-position: 50%;
  width: 100%;
  height: 100%;
  transition: transform 0.5s;
}
.desktop-app-wrapper .projects .project .project-content:hover .image {
  transform: scale(1);
  transition: transform 0.5s;
}
.desktop-app-wrapper .projects .project .project-content .gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background: #2b2b2b;
  background: linear-gradient(180deg, rgba(43, 43, 43, 0), #0a3d6a 40%);
  opacity: 0;
  transition: opacity 0.5s;
}
.desktop-app-wrapper .projects .project .project-content:hover .gradient {
  opacity: 1;
}
.desktop-app-wrapper .projects .project .project-content .text {
  position: absolute;
  z-index: 100;
  color: #fff;
  bottom: 30px;
  left: 35px;
  opacity: 0;
  transform: scale(2);
  transform-origin: left bottom;
  transition: opacity 0.5s, transform 0.5s;
}
.desktop-app-wrapper .projects .project .project-content:hover .text {
  opacity: 1;
  transform: scale(1);
}
.desktop-app-wrapper .projects .project .project-content .text .project-name {
  line-height: 1.25;
  font-size: 38px;
}
.desktop-app-wrapper .page-control {
  width: 200px;
  position: absolute;
  z-index: 2000;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #002c53;
  padding: 8px 15px 6px 15px;
  border-radius: 29px;
  top: -120px;
  right: 0;
}
.desktop-app-wrapper .page-control .number span.current-number {
  color: #5a89b2;
}
.desktop-app-wrapper .page-control .next,
.desktop-app-wrapper .page-control .prev {
  padding: 10px;
  cursor: pointer;
}
.desktop-app-wrapper .page-control .number {
  font-size: 12px;
  font-weight: 700;
  color: #c3c3c3;
  padding-bottom: 3px;
}
.desktop-app-wrapper .page-control .prev,
.page-control .next {
  padding: 10px;
  cursor: pointer;
}
.page-control svg {
  vertical-align: middle;
}
.mobile-app-wrapper .selector .select {
  display: inline-block;
  position: relative;
}
.mobile-app-wrapper .selector .select select {
  outline: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-appearance: none;
  background-color: #002c53;
  border-radius: 50px;
  border: 2.5px solid #fff;
  font-weight: 700;
  font-size: 12px;
  color: #fff;
  padding: 11px 25px 11px 15px;
  text-align: center;
}
.mobile-app-wrapper .selector {
  width: 100%;
  height: 80px;
  padding: 0 20px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.mobile-app-wrapper .projects {
  height: cal(100% - 80px);
  width: 100%;
  position: relative;
}
.mobile-app-wrapper .projects .project-prev {
  transform: translateX(-100%);
}
.mobile-app-wrapper .projects .project {
  transform: translateX(0);
}
.project-item .project-item--content {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}
.mobile-app-wrapper .project-item .mask {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #000;
  background: linear-gradient(180deg, transparent, transparent 50%, #000);
  z-index: 0;
}
.mobile-app-wrapper .project-item h2 {
  font-weight: 500;
  list-style: 1.5s;
  position: relative;
  font-size: 36px;
  letter-spacing: 1.5px;
  color: #fff;
  z-index: 100;
  margin-bottom: 200px;
}
.mobile-app-wrapper .view {
  color: #fff;
  position: absolute;
  bottom: 125px;
  border: 2px solid #fff;
  padding: 6px 35px 6px 35px;
  border-radius: 50px;
}
.mobile-app-wrapper .projects .project-next {
  transform: translateX(100%);
}
.mobile-app-wrapper .controller {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 25px;
  padding: 0 20px;
}
.mobile-app-wrapper a {
  color: #0d6efd;
  text-decoration: none;
}
.mobile-app-wrapper .arrow {
  height: 55px;
  width: 55px;
  border: 2px solid #fff;
  border-radius: 50%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.mobile-app-wrapper .controller h4 {
  font-size: 36px;
  font-weight: 500;
  color: #fff;
}
.mobile-app-wrapper .selector .select svg {
  pointer-events: none;
  position: absolute;
  z-index: 1000;
  width: 10px;
  top: 12px;
  right: 14px;
}
.mobile-app-wrapper .projects .project,
.mobile-app-wrapper .projects .project-next,
.mobile-app-wrapper .projects .project-prev {
  position: absolute;
  background-size: cover;
  background-position: 50%;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.mobile-app-wrapper .app {
  min-height: 0;
  min-height: 850px;
  height: 100%;
  width: 100%;
}
.statistic-content .image img {
  max-width: 50px;
}
</style>
